// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3prch","left":"styles_left__2VwQw","right":"styles_right__1B5bO","alert":"styles_alert__3H8ut"};